import styled from 'styled-components';

export const FormContent = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    margin-top: 0.5rem;
    color: #ed4c4c;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  margin-top: 0.5rem;
`;

export const SkipButton = styled.button`
  background: none;
  border: none;
  color: rgba(45, 46, 54, 0.45);
  font-size: 0.85rem;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;

  &:hover {
    color: rgba(45, 46, 54, 0.7);
  }
`;
